var _defs, _path, _g, _g2, _g3, _g4, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNz = function SvgNz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "nz_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h600v300H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nz_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 300 150H0zm300 0h300L300 150zm0 150h300v150zm0 0v150H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "nz_svg__b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nz_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-.325v.5l1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.19.263-.293-.405L1-.325z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__a",
    transform: "scale(-1 1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__a",
    transform: "rotate(72 0 0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__a",
    transform: "rotate(-72 0 0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__a",
    transform: "scale(-1 1)rotate(72)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00247d",
    fillRule: "evenodd",
    d: "M.004 0h640v480h-640z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-92.947 36.115)scale(.66825)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__b",
    width: "100%",
    height: "100%",
    fill: "#fff",
    transform: "translate(900 120)scale(45.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__b",
    width: "100%",
    height: "100%",
    fill: "#cc142b",
    transform: "matrix(30 0 0 30 900 120)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82 534.179 124.977)scale(.66825)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__b",
    width: "100%",
    height: "100%",
    fill: "#fff",
    transform: "rotate(-82 519.022 -457.666)scale(40.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__b",
    width: "100%",
    height: "100%",
    fill: "#cc142b",
    transform: "rotate(-82 519.022 -457.666)scale(25)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82 534.179 124.977)scale(.66825)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__b",
    width: "100%",
    height: "100%",
    fill: "#fff",
    transform: "rotate(-82 668.57 -327.666)scale(45.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__b",
    width: "100%",
    height: "100%",
    fill: "#cc142b",
    transform: "rotate(-82 668.57 -327.666)scale(30)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-92.947 36.115)scale(.66825)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__b",
    width: "100%",
    height: "100%",
    fill: "#fff",
    transform: "translate(900 480)scale(50.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nz_svg__b",
    width: "100%",
    height: "100%",
    fill: "#cc142b",
    transform: "matrix(35 0 0 35 900 480)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 60,
    d: "m0 0 600 300M0 300 600 0",
    clipPath: "url(#nz_svg__c)",
    transform: "matrix(.60681 0 0 .73139 .004 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#cc142b",
    strokeWidth: 40,
    d: "m0 0 600 300M0 300 600 0",
    clipPath: "url(#nz_svg__d)",
    transform: "matrix(.60681 0 0 .73139 .004 0)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M151.707-.002v79.37H.004v60.68h151.703v79.37h60.682v-79.37h151.703v-60.68H212.389V-.003z",
    clipPath: "url(#nz_svg__c)",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cc142b",
    d: "M163.844.002v91.502H.004v36.408h163.84v91.502h36.408v-91.502h163.84V91.504h-163.84V.002z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }));
};
export default SvgNz;